import { render, staticRenderFns } from "./DigitalPlace.vue?vue&type=template&id=353babf3&"
import script from "./DigitalPlace.vue?vue&type=script&lang=js&"
export * from "./DigitalPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports